<template>
  <div class="error404">
    <div class="grid">
      <div class="grid-lg-6 grid-md-8 grid-sm-12">
        <h1 class="text-t1 mb-4">
          <em>Sidan kunde inte hittas</em>
        </h1>
        <ul class="actions">
          <li>
            <a
              href="https://www.gavlegardarna.se"
              class="link-item link-item-light"
              >Till startsidan</a
            >
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
};
</script>
